import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './pc-story-block.css.lit';
import { ResizeController } from './../../../controllers/resize-controller';

export const featureAlignments = ['left', 'right'] as const;
export type FeatureAlignment = (typeof featureAlignments)[number];
/**
 * Story Block component
 * @element pc-story-block

 */
@customElement('pc-story-block')
export class PCStoryBlock extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  resizeController: ResizeController;
  slots = new SlotsController(this);

  @property({ type: String, attribute: 'feature-alignment' })
  featureAlignment: FeatureAlignment = 'left';

  isMobile: boolean;

  connectedCallback() {
    super.connectedCallback();

    this.resizeController = new ResizeController(this, {
      breakpoints: [992],
    });
  }

  render(): TemplateResult {
    this.isMobile = this.resizeController.currentBreakpointRange === 0;

    return html`
      <div class="story-block">
        ${this.leftColumnTemplate()} ${this.rightColumnTemplate()}
      </div>
    `;
  }

  leftColumnTemplate() {
    if (this.isMobile) {
      return this.featureColumnTemplate();
    } else {
      if (this.featureAlignment === 'left') {
        return this.featureColumnTemplate();
      } else {
        return this.cardsColumnTemplate();
      }
    }
  }

  rightColumnTemplate() {
    if (this.isMobile) {
      return this.cardsColumnTemplate();
    } else {
      if (this.featureAlignment === 'left') {
        return this.cardsColumnTemplate();
      } else {
        return this.featureColumnTemplate();
      }
    }
  }

  featureColumnTemplate() {
    return html`
      <div class="column-left">
        ${this.slots.conditionalSlot('block-title', false)}
        ${this.slots.conditionalSlot('block-description', false, 'description')}
        ${this.slots.conditionalSlot('block-cta', false)}
        ${this.slots.conditionalSlot('block-alert', false)}
        ${this.slots.conditionalSlot('block-image', false)}
      </div>
    `;
  }

  cardsColumnTemplate() {
    return html`
      <div class="column-right">
        ${this.slots.conditionalSlot('block-card', false)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-story-block': PCStoryBlock;
  }
}
